import { Expose, Type } from '@nts/std/serialization';
import { GridColumnsMetaData } from './grid-columns-meta-data';
import { FieldMetaData } from './field-meta-data';
import { FieldTypes } from '@nts/std/types';
import type { GridMetaDataInterface } from '@nts/std/interfaces';

export class GridMetaData extends FieldMetaData implements GridMetaDataInterface {

  constructor() {
    super();
    this.gridColumns = new GridColumnsMetaData();
  }

  @Expose()
  @Type(() => GridColumnsMetaData)
  gridColumns: GridColumnsMetaData;

  @Expose()
  areAllColumnsDisabled: boolean;

  @Expose()
  areAllCommandsDisabled: boolean;

  @Expose()
  showTitle: boolean;

  @Expose()
  showToolbar: boolean;

  @Expose()
  dynamicHeight: boolean;

  @Expose()
  minRowNumberHeight: number;

  override getFieldType(): FieldTypes {
    return FieldTypes.Grid;
  }
}
